import "./App.css";
import Header from "./components/header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Páginas
import Home from "./pages/home";
import Historia from "./pages/historia";
import Produtos from "./pages/products";
import Revenues from "./pages/revenues";
import RevenuesDescription from "./pages/revenues/[id]";
import OndeEncontrar from "./pages/home";
import Contatos from "./pages/contact-us";
import ProductsDescription from "./pages/products/[id]";
import ScrollToTop from "./components/scroll-to-top";
import ModalCookies from "./components/modal-cookies";
import Privacidade from "./pages/privacy-policies";
import WhatsApp from "./components/whatsapp";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<Historia />} />
          <Route path="/products" element={<Produtos />} />
          <Route path="/products/:id" element={<ProductsDescription />} />
          <Route path="/revenues" element={<Revenues />} />
          <Route path="/revenues/:id" element={<RevenuesDescription />} />
          <Route path="/onde-encontrar" element={<OndeEncontrar />} />
          <Route path="/contact-us" element={<Contatos />} />
          <Route path="/privacy-policies" element={<Privacidade />} />
        </Routes>
        {localStorage.getItem("cookies-accepted") !== "true" && (
          <ModalCookies />
        )}
        <WhatsApp />
      </Router>
    </div>
  );
}

export default App;
